import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import NotFound from './pages/NotFound';
import AdminDashboard from './pages/AdminDashboard';
import AuthPage from './pages/AuthPage';
import ContactForm from './pages/ContactForm';
import AdminSmspin from './pages/AdminSmspin';
import InfoTree from './pages/InfoTree';
import TreeInfo from './pages/TreeInfo';
import AddTree from './pages/AddTree';
import AboutUs from './pages/AboutUs';
import TreeForm from './adminside/TreeForm';
import Home from './adminside/Home';
import Tree from './adminside/Tree';
import AdminPinStatus from './adminside/AdminPinStatus';
import AdminReport from './adminside/AdminReport';
import AdminMap from './adminside/AdminMap';
import AdminUserList from './adminside/AdminUserList';
import AdminFaqs from './adminside/AdminFaqs';
import AdminFeedback from './adminside/AdminFeedback';
import BlogSlider from './pages/Blog/BlogSlider';
import Feedback from './pages/Feedback';
import LandingPageMap from './pages/LandingPageMap';
import BlogPost from './pages/Blog/BlogPost'
import BlogModal from './pages/Blog/BlogModal'

import ScrollToTop from './components/ScrollToTop';

import Project from './components/Project';
import Arburetum from './pages/Arburetum';
import Treetify from './pages/Treetify';
import ProtectedRoute from "./components/ProtectedRoute";



function App() {

  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <Router
    future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
    }}
    >
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/project" element={<Project />} />
        <Route path="/Arburetum" element={<Arburetum />} />
        <Route path="/HomePage" element={<HomePage />} />
        <Route path="/Treetify" element={<Treetify />} />
        <Route path="/Admin" element={<AdminDashboard />} />
        <Route path="/AuthPage" element={user ? <Navigate to="/" replace={true} /> : <AuthPage />} />
        <Route path="/ContactForm" element={<ContactForm />} />
        <Route path="/AdminSmspin" element={<AdminSmspin />} />
        <Route path="/InfoTree" element={<InfoTree />} />
        <Route path="/TreeInfo" element={<TreeInfo />} />
        <Route path="/AddTree" element={<ProtectedRoute> <AddTree /> </ProtectedRoute>}/>
        <Route path="/AboutUs" element={<AboutUs />} />
        <>
          <Route
              path="/TreeForm"
              element={
                  <ProtectedRoute adminOnly>
                      <TreeForm />
                  </ProtectedRoute>
              }
          />

          <Route
              path="/Home"
              element={
                  <ProtectedRoute adminOnly>
                      <Home />
                  </ProtectedRoute>
              }
          />

          <Route
              path="/Tree"
              element={
                  <ProtectedRoute adminOnly>
                      <Tree />
                  </ProtectedRoute>
              }
          />

          <Route
              path="/AdminPinStatus"
              element={
                  <ProtectedRoute adminOnly>
                      <AdminPinStatus />
                  </ProtectedRoute>
              }
          />

          <Route
              path="/AdminMap"
              element={
                  <ProtectedRoute adminOnly>
                      <AdminMap />
                  </ProtectedRoute>
              }
          />

          <Route
              path="/AdminUserList"
              element={
                  <ProtectedRoute adminOnly>
                      <AdminUserList />
                  </ProtectedRoute>
              }
          />

          <Route
              path="/AdminReport"
              element={
                  <ProtectedRoute adminOnly>
                      <AdminReport />
                  </ProtectedRoute>
              }
          />

          <Route
              path="/AdminFaqs"
              element={
                  <ProtectedRoute adminOnly>
                      <AdminFaqs />
                  </ProtectedRoute>
              }
          />

          <Route
              path="/AdminFeedback"
              element={
                  <ProtectedRoute adminOnly>
                      <AdminFeedback />
                  </ProtectedRoute>
              }
          />
      </>
        <Route path="/BlogSlider" element={<BlogSlider />} />
        <Route path="/Feedback" element={<Feedback />} />
        <Route path="/LandingPageMap" element={<LandingPageMap />} />
        <Route path="/BlogPost" element={<BlogPost />} />
        <Route path="/BlogModal" element={<BlogModal />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
